import { useEffect, useState } from "react";
import { Stack } from "@/components/layout";
import { Alert, Button, Drawer, Input } from "@/components/ui";
import type { UserDto } from "../types";

export interface ProfileEditDrawerProps {
  open: boolean;
  user: UserDto | null;
  onClose: () => void;
  onSubmit: (input: {
    display_name: string | null;
    email: string | null;
    phone: string | null;
    market_id: string | null;
  }) => Promise<void>;
  busy?: boolean;
  error?: string | null;
}

export function ProfileEditDrawer({
  open,
  user,
  onClose,
  onSubmit,
  busy = false,
  error = null,
}: ProfileEditDrawerProps) {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [marketId, setMarketId] = useState("");

  useEffect(() => {
    if (!user) return;
    setDisplayName(user.display_name ?? "");
    setEmail(user.email ?? "");
    setPhone(user.phone ?? "");
    setMarketId(user.market_id ?? "");
  }, [user]);

  return (
    <Drawer open={open} onClose={onClose} title="Edit profile">
      <Stack gap={16}>
        <Input
          label="Display name"
          value={displayName}
          onChange={(event) => setDisplayName(event.target.value)}
        />
        <Input
          label="Email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <Input
          label="Phone"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
        />
        <Input
          label="Market ID"
          value={marketId}
          onChange={(event) => setMarketId(event.target.value)}
        />
        {error ? (
          <Alert tone="danger" title="Update failed">
            {error}
          </Alert>
        ) : null}
        <Button
          variant="primary"
          loading={busy}
          onClick={() =>
            void onSubmit({
              display_name: displayName.trim() || null,
              email: email.trim() || null,
              phone: phone.trim() || null,
              market_id: marketId.trim() || null,
            })
          }
        >
          Save profile
        </Button>
      </Stack>
    </Drawer>
  );
}
